import { epic, epicOldState } from '@legacyApp/client/modules/app/epicService';
import { of } from 'rxjs';
import { combineEpics } from 'redux-observable';
import { kenoActions } from '@modules/games/Game/store/keno/keno.actions';
import { checkGameForm } from '@modules/games/Game/store/gameValidation/gameValidation.actions';
import { GameType } from '@modules/games/Game/constants/availableGames';
import { GAME_UPDATE_AMOUNT } from '@modules/games/Game/store/game/game.constants';
import transactionService from '@modules/transactions/transactionsService';

const onRiskChangeEpic = epicOldState('onRiskChangeEpic', {
	actions: (ofType) => ofType(kenoActions.riskUpdate().type),
	callback: ({ action, oldState, newState }) => {
		if (
			action.payload !== oldState.keno.risk &&
			newState.keno.drawnNumbers.length > 0
		) {
			return [kenoActions.drawnNumbersUpdate([])];
		}
		return [];
	},
});

const onBetAmountChangeEpic = epic('onBetAmountChangeEpic', {
	actions: (ofType) => ofType(GAME_UPDATE_AMOUNT),
	callback: ({ action, store$ }) => {
		if (
			action.payload.game !== GameType.KENO ||
			store$.value.keno.drawnNumbers.length === 0 ||
			store$.value.gameAutobet.autoBetRolling[GameType.KENO] ||
			Object.keys(store$.value.game.betsAnimated[GameType.KENO]).length
		) {
			return of();
		}

		return of(kenoActions.drawnNumbersUpdate([]));
	},
});

const onSelectedNumbersChangeEpic = epicOldState(
	'onSelectedNumbersChangeEpic',
	{
		actions: (ofType) => ofType(kenoActions.selectedNumbersUpdate().type),
		callback: ({ action, oldState, newState }) => {
			if (
				transactionService.isListDifferent(
					action.payload,
					oldState.keno.selectedNumbers,
				)
			) {
				const actions: any[] = [checkGameForm(GameType.KENO)];
				if (newState.keno.drawnNumbers.length > 0) {
					actions.push(kenoActions.drawnNumbersUpdate([]));
				}
				return actions;
			}
			return [];
		},
	},
);

const kenoEpic = combineEpics(
	onRiskChangeEpic,
	onBetAmountChangeEpic,
	onSelectedNumbersChangeEpic,
);

export default kenoEpic;
